import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import MonacoEditor from 'llm/monaco/MonacoEditor';
import {MONACO_LANGUAGES, MonacoLanguage} from 'llm/monaco/MonacoTypes';
import {GRAY_LIGHT} from 'ui-library/Colors';

export interface PreviewContent {
  kind: 'code';
  code: string;
  language: string;
  label: string;
}

interface PreviewPaneProps {
  content: PreviewContent;
  onClose: () => void;
}

function isMonacoLanguage(language: string): language is MonacoLanguage {
  return (MONACO_LANGUAGES as ReadonlyArray<string>).includes(language);
}

export function PreviewPane({content, onClose}: PreviewPaneProps): JSX.Element {
  return (
    <>
      <div className={css(styles.header)}>
        <span className={css(styles.label)}>{content.label}</span>
        <button
          type="button"
          className={css(styles.closeButton)}
          onClick={onClose}
          aria-label="Close preview"
        >
          &times;
        </button>
      </div>
      {isMonacoLanguage(content.language) ? (
        <MonacoEditor
          width="100%"
          height="100%"
          value={content.code}
          language={content.language}
          theme="vs"
          options={{readOnly: true, minimap: {enabled: false}}}
          className={css(styles.editor)}
        />
      ) : (
        <pre className={css(styles.code)}>
          <code>{content.code}</code>
        </pre>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    fontSize: 14,
    fontWeight: 600,
    borderBottom: `1px solid ${GRAY_LIGHT}`,
    flexShrink: 0,
  },
  label: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: 18,
    lineHeight: 1,
    padding: '0 4px',
    color: 'inherit',
  },
  editor: {
    flex: 1,
    minHeight: 0,
  },
  code: {
    margin: 0,
    padding: 16,
    flex: 1,
    overflow: 'auto',
    minHeight: 0,
  },
});
